<template>
    <div class="bg-white">
    
        <CContainer class="ai-review-container">
            <CRow class="header-row mb-3">
                <CCol class="col-auto">
                    <CButton class="back-button" @click="goBack">←</CButton>
                </CCol>
                <CCol class="col text-center">
                    <h3 class="section-title">AI Review</h3>
                </CCol>
                <CCol class="col-auto text-right">
    
                    <CDropdown :caret="false">
                        <template #toggler-content>
                                    ⋮
</template>
                                    
                        <CDropdownItem @click="deleteVideo">🗑 Delete</CDropdownItem>
                        <CDropdownItem @click="shareVideo">🔗 Share</CDropdownItem>
                    </CDropdown>

   
                </CCol>
            </CRow>
            <!-- Video Review Items -->
            <CRow>
                <CCol>
                    <div class="review-card" v-for="video in videos" :key="video.id">
    
                        <!-- Video Info Section -->
                        <CCol sm="12">
                            <div class="rating-header">
                                <h5 class="rating-label font-color-171717">Rating Video</h5>
                                <CButton class="active-btn" @click="openPopup(video)">{{ video.id === 1 ? "Previous" : "After" }}</CButton>
                            </div>
                            <div class="video-info">
    
                                <!-- <img :src="video.thumbnail" class="video-thumbnail" /> -->
                                <video class="video-thumbnail" :src="video.thumbnail" style="width:100px"></video>
    
                                <div class="video-details">
                                    <div class="video-title-row">
                                        <h5 class="video-title font-color-171717">{{ video.title }}</h5>
                                        <p class="video-size mt-3">{{ video.size }}</p>
                                    </div>
                                    <div class="rating">
                                        <span v-for="star in 5" :key="star" class="star">
                                                        <img v-if="star <= video.rating" :src="require('@/assets/img/new/starorange.png')" width="20px" />
                                                        <img v-else :src="require('@/assets/img/new/nostar.png')" width="20px" />
                                                     </span>
                                    </div>
                                    <p class="date"><img src="../assets/img/new/dot.png" width="8px" class="mr-2" />{{ video.date }}</p>
    
                                </div>
                            </div>
    
    
                        </CCol>
                        <!-- Dynamic Previous / After Button -->
    
                    </div>
                </CCol>
            </CRow>
    
            <!-- Content Suggestion Section -->
            <div class="content-suggestion font-color-171717 mb-5 mt-3">
                <h4 class="custom-16px-500 text-left">Our Text Content Suggestion:</h4>
    
                <div class="suggestion-box custom-bg-EAECF0 p-3">
                    <h5 class="custom-14px-500">List of Strengths</h5>
                    <ul>
                        <li>Engaging Voice: The tone is clear and captivating.</li>
                        <li>Informative Content: Well-structured and concise.</li>
                        <li>Relatable Examples: Resonates with the target audience.</li>
                    </ul>
                    <a href="#" class="read-more">Read More</a>
                </div>
    
                <div class="suggestion-box custom-bg-EAECF0 p-3 mt-3">
                    <h5 class="custom-14px-500">List of Weaknesses</h5>
                    <ul>
                        <li>Repetitive Ideas: Some points are repeated.</li>
                        <li>Lack of Visual Elements: Needs more supporting graphics.</li>
                        <li>Pacing Issues: Some sections may feel rushed or slow.</li>
                    </ul>
                </div>
            </div>
    
          
        </CContainer>
    
        <Footerlayout />

        <div v-if="isPopupDetail" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <CRow class="d-flex justify-content-between align-items-center flex-nowrap">
    <CCol xs="auto">
        <CButton class="active-btn">{{ selectedVideo.id === 1 ? "Previous" : "After" }}</CButton>
    </CCol>
    <CCol xs="auto">
        <CButton class="close-btn" @click="isPopupDetail = false">X</CButton>
    </CCol>
</CRow>
                    <!-- Popup Content -->
                    <div class="text-center mt-3">
                        <video class="video-thumbnail" :src="selectedVideo.thumbnail" controls width="100%"></video>
    
                        <div class="video-details">
                            <div class="video-title-row">
                                <h5 class="video-title font-color-171717">{{ selectedVideo.title }}</h5>
                                <p class="video-size mt-3">{{ selectedVideo.size }}</p>
                            </div>
                            <div class="rating text-left">
                                <span v-for="star in 5" :key="star" class="star">
                                            <img
                                                v-if="star <= selectedVideo.rating"
                                                :src="require('@/assets/img/new/starorange.png')"
                                                width="20px"
                                            />
                                            <img
                                                v-else
                                                :src="require('@/assets/img/new/nostar.png')"
                                                width="20px"
                                            />
                                        </span>
                            </div>
                            <p class="date text-left">
                                <img src="../assets/img/new/dot.png" width="8px" class="mr-2" /> {{ selectedVideo.date }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                        <CButton class="close-btn" @click="isPopupDelete = false">X</CButton>
                    </div>
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 60px" src="../assets/img/new/delete.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Delete Video
                        </h3>
                        <p class="custom-14px-400 font-color-98A2B3">Are you sure want to delete this AI Review OldProduct2025.mp4 from your account?</p>
                        <CButton class="custom-border-purple-white mt-4 font-color-928AFD" @click="closeSuccess" style="width:100px">
                            <span class="ml-2 mr-2">Cancel</span>
                        </CButton>
                        <CButton class="custom-border-purple mt-4 text-white ml-3" @click="openSuccess()" style="width:100px">
                            <span class="ml-2 mr-2">Delete</span>
                        </CButton>

                    
                    </div>
                </div>
            </div>

            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                        <CButton class="close-btn" @click="isPopupSuccess = false">X</CButton>
                    </div>
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 200px" src="../assets/img/new/success.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Video Successfully Deleted
                        </h3>
                        <p class="custom-14px-400 font-color-98A2B3">Are you sure want to delete this AI Review OldProduct2025.mp4 from your account?</p>
                        <CButton class="custom-border-purple mt-4 text-white"  @click="isPopupSuccess = false" style="width:100px">
                            <span class="ml-2 mr-2">OK</span>
                        </CButton>
                    </div>
                </div>
            </div>

            <div v-if="isPopupShareLink" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                        <CButton class="close-btn" @click="isPopupShareLink = false">X</CButton>
                    </div>
                    <!-- Popup content -->
                    <div class="text-center">
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3 mb-4">
                            Share
                        </h3>
                        <CRow class="d-flex justify-content-center align-items-center flex-nowrap">
                            <CCol xs="auto" class="d-flex flex-column justify-content-center align-items-center mx-2">
                                <img src="../assets/img/new/link.png" class="img-fluid icon-share" width="80px"/>
                                <h3 class="custom-12px-500 font-color-171717 mt-2">Link</h3>
                            </CCol>
                            <CCol xs="auto" class="d-flex flex-column justify-content-center align-items-center mx-2">
                                <img src="../assets/img/new/instagram.png" class="img-fluid icon-share" width="80px"/>
                                <h3 class="custom-12px-500 font-color-171717 mt-2">Instagram</h3>
                            </CCol>
                            <CCol xs="auto" class="d-flex flex-column justify-content-center align-items-center mx-2">
                                <img src="../assets/img/new/Facebook.png" class="img-fluid icon-share" width="80px"/>
                                <h3 class="custom-12px-500 font-color-171717 mt-2">Facebook</h3>
                            </CCol>
                            <CCol xs="auto" class="d-flex flex-column justify-content-center align-items-center mx-2">
                                <img src="../assets/img/new/Telegram.png" class="img-fluid icon-share" width="80px"/>
                                <h3 class="custom-12px-500 font-color-171717 mt-2">Telegram</h3>
                            </CCol>
                        </CRow>
                    </div>
                </div>
            </div>
    
    
    </div>
</template>

<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            videos: [{
                    id: 1,
                    title: "Old Product 2025.mp4",
                    date: "12nd January 2024",
                    size: "9 MB",
                    rating: 3,
                    thumbnail: "https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/video/6e3369bd-8318-4534-9fe5-ed851adc3693.webm",
                },
                {
                    id: 2,
                    title: "New Product 2025.mp4",
                    date: "12nd January 2024",
                    size: "9 MB",
                    rating: 4,
                    thumbnail: "https://s3.ap-southeast-1.amazonaws.com/files.interviewrr/video/6e3369bd-8318-4534-9fe5-ed851adc3693.webm",
                }
            ],
            isPopupDetail: false,
            selectedVideo: {},
            isDropdownOpen: false,
            isPopupDelete: false,
            isPopupSuccess: false,
            isPopupShareLink: false
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1); // Navigate to the previous page
        },
        openPopup(video) {
            this.selectedVideo = video;
            this.isPopupDetail = true;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        deleteVideo() {
            this.isPopupDelete = true;
        },
        shareVideo() {
            this.isPopupShareLink = true;
        },
        openSuccess() {
            this.isPopupSuccess = true;
            this.isPopupDelete = false;
        }
    }
};
</script>

<style scoped>
/* AI Review Container */

.ai-review-container {
    padding: 20px;
}

/* Section Title */

.section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #171717;
}

/* Review Card */

.review-card {
    display: flex;
    border-radius: 8px;
    margin-bottom: 10px;
}

/* Video Info */

.video-info {
    display: flex;
    align-items: center;
    width: 100%;
}

/* Video Thumbnail */

.video-thumbnail {
    border-radius: 5px;
    margin-right: 15px;
}

/* Video Details */

.video-details {
    flex: 1;
}

/* Video Title & Size Row */

.video-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Video Title */

.video-title {
    font-size: 12px;
    font-weight: 500;
    margin: 0;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    /* 200% */
    letter-spacing: 0.06px;
}

/* Video Size */

.video-size {
    font-size: 12px;
    color: gray;
    text-align: right;
}

.star {
    font-size: 16px;
    color: #ddd;
    margin: 2px;
}

.star.filled {
    color: #ffcc00;
}

/* Date */

.date {
    font-size: 12px;
    color: gray;
    margin-top: 5px;
}

/* Action Button (Previous/After) */

.action-button {
    margin-top: 10px;
    background-color: #6c5ce7;
    color: white;
    padding: 5px 15px;
    border-radius: 5px;
}

.rating-label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
}

.rating-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.dropdown-menu-custom {
    position: absolute;
    right: 0;
    top: 100%;
    background: white;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    min-width: 120px;
    z-index: 1000;
}
</style>